import { Phone } from 'lucide-react'
import { EmergencyContact } from '../../types'
import { getInitials } from '../../utils/get-initials'

interface ContactCardPros {
  contact: EmergencyContact
}
export const ContactCard = ({ contact }: ContactCardPros) => {
  return (
    <div className="flex flex-row gap-2 bg-primary-white w-full rounded-2xl p-2 justify-between">
      <div className="flex flex-row gap-2 items-center w-full">
        <div className="text-4xl font-bold text-primary-white bg-primary-black p-8 rounded-2xl w-12 h-12 flex items-center justify-center">
          <p className="text-2xl font-bold">
            {getInitials(contact.name ?? '')}
          </p>
        </div>
        <div className="flex flex-col">
          {contact.relationship && (
            <span className="py-1 px-2 bg-neutral-tertiary/10 rounded-lg text-sm line-clamp-1 w-fit text-ellipsis">
              {contact.relationship}
            </span>
          )}

          <p>{contact.name}</p>
        </div>
      </div>
      <a
        className="w-24 items-center rounded-3xl bg-primary-black text-primary-white p-2 px-4 flex flex-row gap-2"
        href={`tel:${contact.phoneNumber}`}
      >
        <p className="text-xl">Call</p>
        <Phone />
      </a>
    </div>
  )
}
